import { gql } from '@apollo/client';

export const CREATE_BAG = gql`
  mutation createBag($name: String!, $depositAmount: Float!) {
    createBag(name: $name, depositAmount: $depositAmount) {
      id
      qrCode
      name
      depositAmount
    }
  }
`;

export const UPDATE_BAG = gql`
  mutation updateBag($id: Int!, $name: String!, $depositAmount: Float!) {
    updateBag(id: $id, name: $name, depositAmount: $depositAmount) {
      id
      qrCode
      name
      depositAmount
    }
  }
`;

export const DELETE_BAG = gql`
  mutation deleteBag($id: Int!) {
    deleteBag(id: $id) {
      id
    }
  }
`;

export const RENT_BAG = gql`
  mutation rentBag($bagId: Int!, $userId: Int!, $depositPaid: Boolean!, $rentalComment: String, $rentalPicture: String) {
    rentBag(bagId: $bagId, userId: $userId, depositPaid: $depositPaid, rentalComment: $rentalComment, rentalPicture: $rentalPicture) {
      id
      rentalDate
      rentalComment
      rentalPicture
      user {
        id
        firstName
      }
    }
  }
`;

export const RETURN_BAG = gql`
  mutation returnBag($rentalId: Int!, $depositReturned: Boolean!, $returnComment: String, $returnPicture: String) {
    returnBag(rentalId: $rentalId, depositReturned: $depositReturned, returnComment: $returnComment, returnPicture: $returnPicture) {
      id
      returnDate
      returnComment
      returnPicture
    }
  }
`;

export const CANCEL_RENTAL = gql`
  mutation cancelBagRental($rentalId: Int!) {
    cancelBagRental(rentalId: $rentalId) {
      id
    }
  }
`;
